const defaultState = {
  show: false,
  user_id: null,
}

const payment = (state = defaultState, action) => {
  switch (action.type) {
    case 'SHOW_MODAL_PAYMENT':
      return {show: action.status, user_id: action.status ? action.user_id : null }
    default:
      return state
  }
}

export default payment;


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/redux/reducers/payment.js